import type { FiltrosDaLista } from '../filtrosDeGmud'

/**
 * As chaves de cache do TanStack Query, num lugar só.
 *
 * Chave montada na mão dentro do componente é como se perde invalidação: depois de
 * aprovar uma GMUD, a lista continua mostrando o estado antigo porque quem invalidou
 * escreveu `['gmud', id]` e quem consultou escreveu `['gmuds', id]`. Aqui as duas
 * pontas usam a mesma função.
 */
export const chaves = {
  /** Tudo de GMUD. Invalidar isto derruba lista, detalhe, ações e histórico. */
  gmuds: () => ['gmuds'] as const,
  lista: (filtros: FiltrosDaLista) => ['gmuds', 'lista', filtros] as const,
  detalhe: (id: number) => ['gmuds', 'detalhe', id] as const,
  acoes: (id: number) => ['gmuds', 'acoes', id] as const,
  historico: (id: number) => ['gmuds', 'historico', id] as const,
  revisoesDePr: (id: number) => ['gmuds', 'revisoes-de-pr', id] as const,
  pareceresDaIa: (id: number) => ['gmuds', 'analises-ia', id] as const,
  anexos: (id: number) => ['gmuds', 'anexos', id] as const,
  situacaoDaIaDeGmud: () => ['gmuds', 'analises-ia', 'situacao'] as const,
  /** Sob `gmuds` de propósito: é uma transição que faz a solicitação entrar ou sair da janela. */
  naProximaJanela: () => ['gmuds', 'na-proxima-janela'] as const,
  referencias: (qual: string) => ['referencias', qual] as const,
  eu: () => ['me'] as const,
  /** Tudo do comitê: a pauta e a janela. */
  cab: () => ['cab'] as const,
  pautaDoComite: () => ['cab', 'pauta'] as const,
  janelaDoComite: () => ['cab', 'janela'] as const,
}
